import React from 'react';
import { DropdownDescriptiveMenu, Label } from '@spark';
import {
    PREDICTION_AUTOMATIC,
    PREDICTION_OPTIONS_WITH_AUTO,
} from '@/config/runtimeStrategyOptions';
import './AdvancedDropdownPanel.css';

const RuntimeStrategySelector = (props) => {
    const predictionStrategy = props.predictionStrategy || PREDICTION_AUTOMATIC;

    const items = PREDICTION_OPTIONS_WITH_AUTO.map((opt) => ({
        title: opt.title,
        description: opt.description,
    }));

    const selectedLabel =
        PREDICTION_OPTIONS_WITH_AUTO.find((opt) => opt.value === predictionStrategy)?.title || '';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: 286 }}>
            <Label label="Prediction Strategy" showAsterisk={false} showIcon={false} />
            <DropdownDescriptiveMenu
                panelLayout="overlay"
                placeholder="Select prediction strategy"
                value={selectedLabel}
                items={items}
                onSelect={(item, index) => {
                    props.onPredictionStrategyChange(PREDICTION_OPTIONS_WITH_AUTO[index].value);
                }}
                size="medium"
                panelClassName="train-advanced-dropdown-panel"
            />
        </div>
    );
};

export default RuntimeStrategySelector;
